
<template>
    
        <c-popup v-if="isShow" :show="isShow" :shadow-close="shadowClose" @close="close" class="normal-popup"><mars-view class="apply-popup-intro"><mars-view class="title">
            选择咨询类型
        </mars-view><mars-view class="title-close" @click.native.stop="close"><mars-view class="close"></mars-view></mars-view><mars-view class="area-box"><mars-view v-for="(item, index) in typeList" :key="index" class="area-item" :class="{'area-item-active': item.value === curType, 'isHasBg': hasActiveBg}" @click.native="onTypeClick(item)">
                {{ item.value }}
            </mars-view></mars-view></mars-view></c-popup>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import Popup from "../common/newPopup.vue";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    shadowClose: {
      type: Boolean,
      default: false
    },
    // 选择类型
    curType: {
      type: String,
      value: ''
    },
    hasActiveBg: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 咨询类型-列表
      typeList: [{
        value: '交通运输',
        group: '交通律师'
      }, {
        value: '婚姻继承',
        group: '婚姻律师'
      }, {
        value: '劳动社保',
        group: '劳动律师'
      }, {
        value: '经济纠纷',
        group: '经济律师'
      }, {
        value: '合同纠纷',
        group: '合同律师'
      }, {
        value: '刑事案件',
        group: '刑事律师'
      }, {
        value: '行政相关',
        group: '行政律师'
      }, {
        value: '房地产',
        group: '房产律师'
      }, {
        value: '其他',
        group: '专业律师'
      }]
    };
  },
  components: {
    'c-popup': Popup
  },
  methods: {
    /**
     * 关闭弹窗
     */

    close() {
      this.$emit('close');
    },
    /**
     * 选项选择
     * @param {object} info event对象
     */

    onTypeClick(info = {}) {
      let {
        value,
        group
      } = info;
      if (!value || value === this.curType) {
        return;
      }
      this.$emit('typeChange', {
        group,
        value
      });
      this.close();
    }
  }
};
</script>

<style scoped>
.apply-popup-intro {
  padding: 4.35vw 4.11vw 11.35vw;
}
.apply-popup-intro .title-close {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5.14vw;
  height: 5.14vw;
  right: 3.11vw;
  top: 4vw;
}
.apply-popup-intro .title-close .close {
  width: 3.14vw;
  height: 3.14vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-popup-close-icon.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.apply-popup-intro .title {
  font-family: "PingFang SC";
  font-size: 4.35vw;
  font-style: normal;
  text-align: center;
  font-weight: 500;
  line-height: 4.35vw;
  padding-bottom: 4.59vw;
}
.apply-popup-intro .area-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.apply-popup-intro .area-box .area-item {
  font-family: "PingFang SC";
  margin-top: 3.14vw;
  width: 28.5vw;
  height: 9.66vw;
  background: #f5f6f9;
  margin-right: 3.14vw;
  border-radius: 2.17vw;
  text-align: center;
  line-height: 9.66vw;
  font-size: 3.86vw;
  color: #848691;
}
.apply-popup-intro .area-box .area-item-active {
  color: #05f;
  font-weight: 600;
}
.apply-popup-intro .area-box .area-item-active.isHasBg {
  background: rgba(0, 85, 255, 0.1);
}
.apply-popup-intro .area-box .area-item:nth-of-type(3n) {
  margin-right: 0;
}

</style>
